import { useState } from 'react';
import {
    ColumnOrderState,
    ColumnPinningState,
    ExpandedState,
    PaginationState,
    SortingState,
    VisibilityState,
} from '@tanstack/react-table';
import {
    GivebutterColumnFilterState,
    InitialTableState,
    RowPendingState,
    RowReplacementState,
} from 'types/react-table';

const PAGE_INDEX = 0;
const PAGE_SIZE = 20;

const useReactTableState = (initialState: InitialTableState = {}) => {
    const {
        isTableFilterBarExpanded = false,
        pageSize = PAGE_SIZE,
        sortingState = [],
        columnVisibilityState = {},
        columnPinningState = {},
        columnOrderState = [],
        rowPendingState = [],
        rowReplacementState = [],
        givebutterColumnFiltersState = {},
        isAllRecordsSelectedState = false,
    } = initialState;
    const [expanded, setExpanded] = useState<ExpandedState>({});
    const [columnVisibility, setColumnVisibility] =
        useState<VisibilityState>(columnVisibilityState);
    const [sorting, setSorting] = useState<SortingState>(sortingState);
    const [pagination, setPagination] = useState<PaginationState>({
        pageIndex: PAGE_INDEX,
        pageSize: pageSize,
    });
    const [columnOrder, setColumnOrder] = useState<ColumnOrderState>(columnOrderState);
    const [columnPinning, setColumnPinning] = useState<ColumnPinningState>(columnPinningState);
    const [rowPending, setRowPending] = useState<RowPendingState>(rowPendingState);
    const [rowReplacement, setRowReplacement] = useState<RowReplacementState>(rowReplacementState);
    const [givebutterColumnFilters, setGivebutterColumnFilters] =
        useState<GivebutterColumnFilterState>(givebutterColumnFiltersState);
    const [isFilterBarExpanded, setIsFilterBarExpanded] = useState(isTableFilterBarExpanded);
    const [isAllRecordsSelected, setIsAllRecordsSelected] = useState(isAllRecordsSelectedState);

    return {
        expanded,
        setExpanded,
        //
        pagination,
        setPagination,
        //
        columnVisibility,
        setColumnVisibility,
        //
        sorting,
        setSorting,
        //
        columnOrder,
        setColumnOrder,
        //
        columnPinning,
        setColumnPinning,
        //
        rowPending,
        setRowPending,
        //
        rowReplacement,
        setRowReplacement,
        //
        givebutterColumnFilters,
        setGivebutterColumnFilters,
        //
        isFilterBarExpanded,
        setIsFilterBarExpanded,
        //
        isAllRecordsSelected,
        setIsAllRecordsSelected,
    };
};

export { useReactTableState };
